import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fissato" }, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Benvenuti"),
    /*#__PURE__*/_createElementVNode("h2", null, "Nell'area clienti")
  ])
], -1)
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { id: "formContent" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "logo_sel1.png",
    id: "icon",
    class: "m-3",
    alt: "User Icon"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "py-2 text-red-600 font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "login",
          class: "my-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          name: "login",
          placeholder: "username"
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          class: "my-input",
          placeholder: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        (_ctx.errorInfo !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorInfo), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "submit",
          value: "LOGIN",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
        })
      ])
    ])
  ]))
}